import './ChipComponent.scss'
import React from "react";
import {MIXED_CATEGORIES_LABEL, UNCATEGORIZED_LABEL, UNCATEGORIZED_VALUE} from "../../constants";
import {Chip, Tooltip} from "@mui/material";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import type {TaxonomyCategory} from "../../stores/TaxonomyCategoryProvider";
import {useStores} from "../../stores";
import {categoryNameCutoffEllipsisLength, doEllipsisCutoff} from "../../utils/str.utils";
import {DEFAULT_CATEGORY_COL_WIDTH} from "../../stores/ProfileStore.tsx";

const NEXT_ICON_SIZE = 21;

type Props = {
    category: string[] | false | 'UNCATEGORIZED' | 'MIXED_CATEGORIES' | TaxonomyCategory
    showCategoryId?: boolean,
    colWidth?: number,
}
export const CategorizationViewOnlyComponent: React.FC<Props> = ({category, showCategoryId, colWidth}) => {
    const {p} = useStores();

    const isArray = Array.isArray(category);
    if (category === false || (isArray && (category as string[]).every(c => c === UNCATEGORIZED_VALUE) || category === 'UNCATEGORIZED')) {
        return <>{UNCATEGORIZED_LABEL}</>;
    }
    if (category === 'MIXED_CATEGORIES') {
        return <>{MIXED_CATEGORIES_LABEL}</>;
    }

    let cats: string[];
    let customerCategoryId: string;
    if (isArray) {
        cats = (category as string[]);
        customerCategoryId = '';
    } else {
        const c: TaxonomyCategory = (category as TaxonomyCategory);
        cats = c.data.labels;
        customerCategoryId = c.data.category_id || '';
    }

    const maxLabelWidth = (colWidth ?? p.p.cat_col_width ?? DEFAULT_CATEGORY_COL_WIDTH)
        // To accommodate for the ">" between chips
        - NEXT_ICON_SIZE;
    const maxLabelLength = categoryNameCutoffEllipsisLength(maxLabelWidth);

    return <>
        {showCategoryId && customerCategoryId && <>
            <span className="part-cat-component-category-id">{customerCategoryId}</span>
        </>}
        {cats.map((c, i) => {
            const categoryLabel = c === UNCATEGORIZED_VALUE ? UNCATEGORIZED_LABEL : c;
            const [s, cutoff] = doEllipsisCutoff(categoryLabel, maxLabelLength);

            const chip = <>
                <Chip
                    className="category-chip"
                    variant="outlined"
                    size="small"
                    label={s}
                />
                {(i < cats.length - 1) && <NavigateNextIcon fontSize="small"/>}
            </>
            if (cutoff) {
                return <Tooltip key={i} title={categoryLabel}><span>{chip}</span></Tooltip>
            } else {
                return <React.Fragment key={i}>{chip}</React.Fragment>;
            }
        })}
    </>
};